export class RequestItemError {
    resultCode: string
    message: string
    messageId: string
    fields?: string[]

    constructor(resultCode: string, message: string, messageId: string, fields?: string[]) {
        this.resultCode = resultCode
        this.message = message
        this.messageId = messageId
        this.fields = fields
    }

    static from(json: any): RequestItemError {
        return new RequestItemError(
            json.resultCode,
            json.message,
            json.messageId,
            json.fields,
        )
    }
}
